export const getSubscribeId = topic => {
  return JSON.stringify({
    channel: 'Pwa::ExitAuthorizationsChannel',
    topic
  })
}
